<template>
  <div class="" id="pageTop" style="padding:1rem 1rem 10rem">
    <div class="row">
      <div class="col-12 h3 mb-3 text-primary">Conferences</div>
      <div class="col-12 col-md-4 pointer my-2 d-flex align-items-stretch" v-for="conf in confList" :key="conf.id">
        <div class="col-12 card text-white" :class="conf.data.conftype === 'rotaract' ? 'bg-danger' : 'bg-primary'" @click="$router.push(`/${conf.id}`)">
          <div class="card-body">
            <h4 class="">
				
              {{conf.data.confname}}
            </h4>
            <h6>
              <small>{{conf.data.confloc}}, <br/>{{conf.data.confdate}}</small>
            </h6>
            <hr size="1"/>
            <p>
              <small>Conference Secretary:</small>
              <br/><span class="h5">{{conf.data.confsec}}</span>
              <br/>{{conf.data.confemail}}
              <br/>{{conf.data.confphone}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//const fb = require("../firebaseConfig")
export default {
  name: "Index",
  components: {
  },
  computed:{
    confList(){
      return this.$store.state.confList
    }
  },
  data(){
    return{
      //confList:[]
    }
  },
  mounted(){
    

  }
}
</script>
